<template>
  <div class="login">
    <div class="login__inner">
      <div class="login__form-wrap">
        <el-form :model="loginForm" ref="loginForm" class="login__form" :rules="rules">
          <el-form-item prop="username">
            <i class="icon iconfont icon-user login__fill"></i>
            <el-input
              v-model="loginForm.username"
              type="age"
              placeholder="用户名"
              @keyup.enter.native="submitForm('loginForm')"
              class="login_input__common"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <i class="icon iconfont icon-3 login__fill"></i>
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="密码"
              @keyup.enter.native="submitForm('loginForm')"
              class="login_input__common"
            ></el-input>
          </el-form-item>
          <el-form-item prop="verifyCode" class="clearfix">
            <el-input
              v-model="loginForm.verifyCode"
              class="login__input-code fl"
              type="age"
              placeholder="验证码"
              @keyup.enter.native="submitForm('loginForm')"
            ></el-input>
            <i
              class="icon iconfont icon-shuaxin login__refresh-code fl"
              :class="{ 'login__refresh': refreshing }"
              @click="getVerifyCode"
              ref="refresh"
            ></i>
            <i class="login__verifycode fl" @click="getVerifyCode">
              <img :src="verifyCodeUrl" alt />
            </i>
          </el-form-item>
          <el-form-item class="login__btn-wrap">
            <el-switch :width="36" v-model="remember" active-color="#E21D25" on-text off-text></el-switch>
            <span class="login__remember">记住密码</span>
            <el-button
              :disabled="submiting"
              class="login__btn"
              type="primary"
              @click="submitForm('loginForm')"
            >{{ submiting ? '登录中' : '登录' }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <p class="login__support">仅支持谷歌浏览器，QQ浏览器，搜狗浏览器，火狐浏览器，360浏览器（极速模式），Microsoft Edge浏览器访问广告平台</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { Base64 } from 'js-base64';
import * as Cookies from 'js-cookie';
import * as store from 'store';
import { COOKIE_USER, COOKIE_PWD, STORE_USER_ID } from '@/global/util/constants'
import { tip } from '@/global/util/util'

export default {
  name: 'Login',
  data () {
    return {
      loginForm: {
        username: '',
        password: '',
        verifyCode: ''
      },
      rules: {
        username: [{ required: true, message: '请选择用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        verifyCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      verifyCodeUrl: '',
      remember: true,
      refreshing: false,
      platform: '',
      path: '',
      cookie: {
        user: '',
        pwd: ''
      },
      submiting: false,
      from: ''
    };
  },
  created () {
    this.getVerifyCode()
    this.from = this.$route.query.from
    const { platform, path } = this.$router.currentRoute.meta;
    const user = `${platform}:${COOKIE_USER}`;
    const pwd = `${platform}:${COOKIE_PWD}`;
    this.platform = platform;
    this.path = path;
    this.cookie.user = user;
    this.cookie.pwd = pwd;
    // 填充表单
    const username = Cookies.get(user);
    const password = Cookies.get(pwd);
    if (username && password) {
      this.loginForm.username = username;
      this.loginForm.password = Base64.decode(password);
      this.remember = true;
    }
  },
  methods: {
    ...mapActions(['login/login', 'login/getVerifyCode', 'login/getUser', 'login/getBalance']),
    ...mapMutations(['login/setUserid']),
    submitForm (loginForm) {
      this.$refs[loginForm].validate(async (valid) => {
        if (valid) {
          if (this.submiting) return;
          this.submiting = true;

          const { loginForm: { username, password, verifyCode }, platform, path } = this;
          const { user, pwd } = this.cookie;
          if (this.remember) {
            Cookies.set(user, username, { expires: 7 });
            Cookies.set(pwd, Base64.encode(password), { expires: 7 });
          } else {
            Cookies.remove(user);
            Cookies.remove(pwd);
          }

          const data = { username, password, rand_code: verifyCode }
          if (['ka', 'ad-user', 'agency'].includes(platform) && this.from) {
            data.from = this.from
          }

          this.$store.dispatch('login/login', { platform, data }).then((data) => {
            if (data.code === 1) {
              store.set(`${platform}:${STORE_USER_ID}`, data.data.id)
              this['login/getUser']({ platform, userid: data.data.id })
              this['login/setUserid'](data.data.id)
              const platformMap = {
                'agency': '1',
                'ka': '2',
                'admin': '3',
                'ad-user': '4'
              }
              this['login/getBalance']({
                platform,
                data: {
                  account_id: data.data.id,
                  user_type: platformMap[platform]
                }
              })
              this.$router.push(path || '/')
            } else {
              Cookies.remove(user);
              Cookies.remove(pwd);
              store.remove(`${platform}:${STORE_USER_ID}`)
              tip(`${data.msg}`);
              this.getVerifyCode();
            }

            this.submiting = false
            // const codes = new Map()
            //   .set(1, '登录成功')
            //   .set(-133, '验证码错误')
            //   .set(-111, '账号错误')
            //   .set(-112, '密码错误');
            // const code = this.loginResult.code;
            // this.$message({
            //   showClose: true,
            //   message: `${codes.get(code)}！`,
            //   type: code === 1 ? 'success' : 'error'
            // });
            // if (code === 1) return this.$router.push('/home');
            // this.getVerifyCode();
          });
        }
      });
    },
    getVerifyCode () {
      this.refreshing = true
      setTimeout(() => (this.refreshing = false), 1000)
      this['login/getVerifyCode']().then((data) => {
        this.loginForm.verifyCode = '';
        if (data && data.code === 1) {
          this.verifyCodeUrl = data.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" type="text/scss">
.login {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 944px;
  min-height: 648px;
  // background-color: #e74235;
  background: url(../../assets/images/login.png) no-repeat top center/cover;

  .el-input {
    height: 45px;
  }
  .el-form-item {
    &__content {
      line-height: 45px;
    }
    &__error {
      margin-left: 0;
    }
  }
  .login__inner {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -472px;
    margin-top: -324px;
    width: 944px;
    height: 648px;
    background: url(../../assets/images/loginBox01.png) no-repeat;
  }
  .login__form-wrap {
    width: 272px;
    height: 395px;
    margin-left: 300px;
    padding: 236px 40px 0;
    color: #123422;
    .el-form-item {
      position: relative;
      margin-bottom: 15px;

      &.is-error {
        .el-input__inner {
          border-bottom: 1px solid #f56c6c;
        }
      }
    }
    .el-input__inner {
      height: 45px;
      padding-left: 30px;
      font-size: 16px;
      line-height: 45px;
      color: #123422;
      text-align: left;
      background: transparent;
      border: none;
      border-bottom: 1px solid #dbdadc;
      border-radius: 0 0;
    }
    input {
      &::-webkit-input-placeholder,
      &:-moz-placeholder,
      &::-moz-placeholder,
      &:-ms-input-placeholder {
        color: #b8b8b8;
        font-size: 16px;
      }
    }
  }
  .login__form {
    width: 272px;
    margin: 0 auto;
    .login_input__common {
      width: 100%;
    }
  }
  .login__fill {
    position: absolute;
    left: 0;
    bottom: 0;
    color: #bcbcbc;
  }
  .login__input-code {
    width: 137px;
  }
  .login__verifycode {
    display: inline-block;
    width: 82px;
    height: 30px;
    margin: 14px 0 0 12px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .login__refresh-code {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-top: 23px;
    margin-left: 27px;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    color: #e21d25;
    transform-origin: 50% 50%;
  }
  .login__btn-wrap {
    margin-top: 136px;
  }
  .login__remember {
    color: #e21d25;
    margin-left: 5px;
  }
  .login__btn {
    width: 127px;
    height: 31px;
    margin-left: 39px;
    padding: 0;
    font-size: 14px;
    color: #e21d25;
    background: transparent;
    border: 1px solid #e21d25;
    border-radius: 20px 20px;
    transition: all 0.3s;
    &:hover {
      color: #fff;
      background: #e21d25;
    }
  }
  .login__refresh {
    transition: all 0.6s;
    transform: rotate(360deg);
  }
  .login__support {
    margin-top: 20px;
    text-align: center;
    font-size: 12px;
    color: #bc1600;
  }
}
</style>
